import { render, staticRenderFns } from "./askQuestion.vue?vue&type=template&id=5aa3712d&scoped=true&"
import script from "./askQuestion.vue?vue&type=script&lang=js&"
export * from "./askQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa3712d",
  null
  
)

export default component.exports